module.exports = __webpack_public_path__ + "img/20210314_120206.d93ad4af.jpg";